import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import { Icon, Image, Message, Popup } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import { ReduxFormHiddenRecord } from 'components';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

class StartExamWizardContentStep1 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { examPrepareData, navigatePage, reactivateValidate } = this.props;

    const level = {
      positive: {
        type: { positive: true },
        icon: { name: 'check circle' }
      },
      warning: {
        type: { warning: true },
        icon: { name: 'warning circle' }
      },
      error: {
        type: { error: true },
        icon: { name: 'remove circle' }
      }
    };

    let isFail = 0;
    const checkInfo = [];
    // STMP 설정
    if (typeof examPrepareData.mailSmtpTested !== 'undefined' && examPrepareData.mailSmtpTested === '1') {
      checkInfo.push(
        <div className={cx('each-preCheck')} key="1">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_check.png" />
          <div className={cx('preCheck-text')}>
            {defineMessages(
              formatMessage({
                id: 'StartExamWizardContent_60',
                defaultMessage: 'SMTP 설정 및 테스트 완료'
              })
            )}
          </div>
          <div className={cx('preCheck-extra')}>
            <Popup
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_60',
                  defaultMessage: 'SMTP 설정 및 테스트 완료'
                })
              )}
            />
          </div>
        </div>
      );
    } else {
      isFail = 1;
      checkInfo.push(
        <div className={cx('each-preCheck')} key="1">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_fail.png" />
          <div className={cx('preCheck-text')}>
            {ReactHtmlParser(
              defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_61',
                  defaultMessage: 'SMTP 설정 및 테스트 미수행'
                })
              )
            )}
          </div>
          <div className={cx('preCheck-extra')}>
            <Tooltip
              title={defineMessages(
                formatMessage({ id: 'StartExamWizardContent_62', defaultMessage: 'SMTP 설정으로 이동' })
              )}
              placement="top">
              <Image
                src="/img/examStart/btn_arrow.png"
                onClick={(e, data) => {
                  navigatePage('/main/mypage/smtp');
                }}
              />
            </Tooltip>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_6',
                  defaultMessage: '대상자 메일의 SMTP 서버 정보를 입력하고 제공된 동작 테스트를 해보세요.'
                })
              )}
            />
          </div>
        </div>
      );
    }

    // 훈련 대상자 체크
    if (typeof examPrepareData.targetCount !== 'undefined' && examPrepareData.targetCount > 0) {
      checkInfo.push(
        <div className={cx('each-preCheck')} key="2">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_check.png" />
          <div className={cx('preCheck-text')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_63', defaultMessage: '훈련 대상자 있음' }))}
            <span className={cx('sub-info')}>
              {' (' +
                examPrepareData.targetCount +
                defineMessages(formatMessage({ id: 'StartExamWizardContent_13', defaultMessage: '명' })) +
                ')'}
            </span>
          </div>
          <div className={cx('preCheck-extra')}>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_7',
                  defaultMessage:
                    '훈련 대상자를 등록하세요. 단일 대상자를 입력하여 등록하거나 지정된 형식의 엑셀로 일괄 등록이 가능합니다.'
                })
              )}
            />
          </div>
        </div>
      );
    } else {
      isFail = 1;
      checkInfo.push(
        <div className={cx('each-preCheck')} key="2">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_fail.png" />
          <div className={cx('preCheck-text')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_64', defaultMessage: '훈련 대상자 없음' }))}
          </div>
          <div className={cx('preCheck-extra')}>
            <Tooltip
              title={defineMessages(
                formatMessage({ id: 'StartExamWizardContent_65', defaultMessage: '대상 관리로 이동' })
              )}
              placement="top">
              <Image
                src="/img/examStart/btn_arrow.png"
                onClick={(e, data) => {
                  navigatePage('/main/target');
                }}
              />
            </Tooltip>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_7',
                  defaultMessage:
                    '훈련 대상자를 등록하세요. 단일 대상자를 입력하여 등록하거나 지정된 형식의 엑셀로 일괄 등록이 가능합니다.'
                })
              )}
            />
          </div>
        </div>
      );
    }

    // 태그 체크
    if (typeof examPrepareData.tagCount !== 'undefined' && examPrepareData.tagCount > 0) {
      checkInfo.push(
        <div className={cx('each-preCheck')} key="3">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_check.png" />
          <div className={cx('preCheck-text')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_66', defaultMessage: '훈련 대상 태그 있음' }))}
            <span className={cx('sub-info')}>
              {' (' +
                examPrepareData.tagCount +
                defineMessages(formatMessage({ id: 'StartExamWizardContent_67', defaultMessage: '개' })) +
                ')'}
            </span>
          </div>
          <div className={cx('preCheck-extra')}>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_8',
                  defaultMessage:
                    '훈련 대상자에 태그를 부여하면 태그를 이용하여 한번에 여러명의 대상자를 선택할 수 있습니다.'
                })
              )}
            />
          </div>
        </div>
      );
    } else {
      isFail = 1;
      checkInfo.push(
        <div className={cx('each-preCheck')} key="3">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_info.png" />
          <div className={cx('preCheck-text')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_68', defaultMessage: '훈련 대상 태그 없음' }))}
          </div>
          <div className={cx('preCheck-extra')}>
            <Tooltip
              title={defineMessages(
                formatMessage({ id: 'StartExamWizardContent_65', defaultMessage: '대상 관리로 이동' })
              )}
              placement="top">
              <Image
                src="/img/examStart/btn_arrow.png"
                onClick={(e, data) => {
                  navigatePage('/main/target');
                }}
              />
            </Tooltip>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_8',
                  defaultMessage:
                    '훈련 대상자에 태그를 부여하면 태그를 이용하여 한번에 여러명의 대상자를 선택할 수 있습니다.'
                })
              )}
            />
          </div>
        </div>
      );
    }

    // 훈련 양식 체크
    if (typeof examPrepareData.templateCheckCount !== 'undefined' && examPrepareData.templateCheckCount > 0) {
      checkInfo.push(
        <div className={cx('each-preCheck')} key="4">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_check.png" />
          <div className={cx('preCheck-text')}>
            {defineMessages(
              formatMessage({
                id: 'StartExamWizardContent_69',
                defaultMessage: '성공적으로 발송된 훈련 양식(템플릿)이 있음'
              })
            )}
            <span className={cx('sub-info')}>
              {' (' +
                examPrepareData.templateCheckCount +
                defineMessages(formatMessage({ id: 'StartExamWizardContent_67', defaultMessage: '개' })) +
                ')'}
            </span>
          </div>
          <div className={cx('preCheck-extra')}>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_9',
                  defaultMessage:
                    '훈련 메일이 스팸 차단 솔루션 등에 의해 차단될 수 있습니다. 미리 본인 메일로 발송하여 정상 수신 여부를 확인해 보세요.'
                })
              )}
            />
          </div>
        </div>
      );
    } else {
      isFail = 1;
      checkInfo.push(
        <div className={cx('each-preCheck')} key="4">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_info.png" />
          <div className={cx('preCheck-text')}>
            {defineMessages(
              formatMessage({
                id: 'StartExamWizardContent_70',
                defaultMessage: '성공적으로 발송된 훈련 양식(템플릿)이 없음'
              })
            )}
          </div>
          <div className={cx('preCheck-extra')}>
            <Tooltip
              title={defineMessages(
                formatMessage({ id: 'StartExamWizardContent_71', defaultMessage: '템플릿 관리로 이동' })
              )}
              placement="top">
              <Image
                src="/img/examStart/btn_arrow.png"
                onClick={(e, data) => {
                  navigatePage('/main/mypage/examtemplate');
                }}
              />
            </Tooltip>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_9',
                  defaultMessage:
                    '훈련 메일이 스팸 차단 솔루션 등에 의해 차단될 수 있습니다. 미리 본인 메일로 발송하여 정상 수신 여부를 확인해 보세요.'
                })
              )}
            />
          </div>
        </div>
      );
    }

    // 라이센스 체크
    if (examPrepareData.licenseDetailEnc) {
      checkInfo.push(
        <div className={cx('each-preCheck')} key="5">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_check.png" />
          <div className={cx('preCheck-text')}>
            {defineMessages(
              formatMessage({ id: 'StartExamWizardContent_72', defaultMessage: '서비스 이용 라이센스 있음' })
            )}
          </div>
          <div className={cx('preCheck-extra')}>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_10',
                  defaultMessage: '라이센스를 구매하면 보다 많은 인원을 대상으로 무제한 훈련이 가능합니다. '
                })
              )}
            />
          </div>
        </div>
      );
    } else {
      isFail = 1;
      checkInfo.push(
        <div className={cx('each-preCheck')} key="5">
          <Image className={cx('preCheck-valiImage')} src="/img/examStart/ico_fail.png" />
          <div className={cx('preCheck-text')}>
            {ReactHtmlParser(
              defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_73',
                  defaultMessage: '서비스 이용 라이센스 없음 <span class="sub-info">(발송 대상 5명으로 제한됨)</span>'
                })
              )
            )}
          </div>
          <div className={cx('preCheck-extra')}>
            <Tooltip
              title={defineMessages(
                formatMessage({ id: 'StartExamWizardContent_74', defaultMessage: '라이센스 구매로 이동' })
              )}
              placement="top">
              <Image
                src="/img/examStart/btn_arrow.png"
                onClick={(e, data) => {
                  navigatePage('/main/mypage/license');
                }}
              />
            </Tooltip>
            <Popup
              className="max-250"
              position="right center"
              trigger={<Image src="/img/examStart/btn_qmark.png" />}
              content={defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_10',
                  defaultMessage: '라이센스를 구매하면 보다 많은 인원을 대상으로 무제한 훈련이 가능합니다. '
                })
              )}
            />
          </div>
        </div>
      );
    }

    let summary = (
      <div className={cx('precheck-summary')}>
        {defineMessages(
          formatMessage({
            id: 'StartExamWizardContent_75',
            defaultMessage: '훈련에 필요한 모든 사항이 올바르게 설정되었습니다.'
          })
        )}
      </div>
    );
    if (isFail) {
      summary = (
        <div className={cx('precheck-summary notEnough')}>
          {defineMessages(
            formatMessage({
              id: 'StartExamWizardContent_76',
              defaultMessage: '훈련이 가능하지만 아래 사항을 먼저 확인하는 것이 좋습니다.'
            })
          )}
        </div>
      );
    }

    return (
      <div className={cx('precheck-area')}>
        {summary}
        <div className={cx('precheck-content')}>{checkInfo}</div>
        {/* 아래 Input 은 redux-form 버그로 인한 임시방편 */}
        <ReduxFormHiddenRecord
          name="examReactiveValidator"
          validate={['maxLength100']}
          valuePass={reactivateValidate}
        />
      </div>
    );
  }
}

export default injectIntl(StartExamWizardContentStep1);



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamWizardContentStep1.js